import PropTypes from "prop-types";
import { RadioButtonUnchecked, CheckCircle } from "@material-ui/icons";
import { Grid, Typography } from "@material-ui/core";
import { ReactNode, ReactChild } from "react";
import useStyles from "./styles";
import { translate as t } from "../../../infrastructure/translate/localization";
import TooltipIcon from "../TooltipIcon";
import CobeeTooltip from "../CobeeTooltip";

export default function BenefitTypeToggleCard({
  checked,
  name,
  cardImg,
  onChange,
  tooltipContent,
  action,
  benefitPlan,
  disabled,
  isConfigEditable,
  icon,
}: {
  checked?: boolean;
  name?: string;
  cardImg?: string;
  onChange: (e: any) => void;
  tooltipContent?: ReactNode;
  action?: (e: any) => void;
  benefitPlan?: any;
  disabled?: boolean;
  isConfigEditable?: boolean;
  icon?: boolean;
}) {
  const {
    container,
    mediaContainer,
    radio,
    radioContainer,
    radioText,
    actionLabel,
    benefitName,
    image,
  } = useStyles({ checked, image: cardImg, disabled, cardImg });
  return (
    <Grid item className={container} container alignContent="space-between">
      <Grid item container justify="flex-end" style={{ minHeight: "24px" }}>
        {icon ? (
          <CobeeTooltip title={tooltipContent as ReactChild}>
            <div>
              <TooltipIcon disabled={disabled} />
            </div>
          </CobeeTooltip>
        ) : (
          <></>
        )}
      </Grid>

      <Grid item container xs={12}>
        <Grid
          item
          xs={12}
          container
          justify="center"
          className={mediaContainer}
        >
          <div className={image} />
        </Grid>
        <Grid item xs={12} container justify="center">
          <Typography variant="body1" className={benefitName}>
            {name}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        container
        justify="space-between"
        alignItems="flex-end"
      >
        <Grid
          item
          xs={9}
          container
          alignItems="center"
          className={radioContainer}
          onClick={() => onChange(!checked)}
        >
          {checked ? (
            <CheckCircle className={radio} />
          ) : (
            <RadioButtonUnchecked className={radio} />
          )}
          <Typography variant="body2" className={radioText}>
            {t(`benefits-section.${checked ? "activated" : "activate"}`)}
          </Typography>
        </Grid>

        <Grid item xs={3} container justify="flex-end">
          {action && checked && isConfigEditable && (
            <Typography
              variant="body2"
              onClick={() => action(benefitPlan)}
              className={actionLabel}
            >
              {t("actions.adjustments")}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

BenefitTypeToggleCard.defaultProps = {
  checked: false,
  tooltipContent: "",
  action: undefined,
  cardImg: undefined,
  disabled: false,
  isConfigEditable: false,
};

BenefitTypeToggleCard.propTypes = {
  checked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  cardImg: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  action: PropTypes.func,
  benefitPlan: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  isConfigEditable: PropTypes.bool,
};
